define('drops/radioButtonGroupV2/radioButtonGroupV2',[
    'jquery',
    'lq/drop',
    'lq/util',
    'underscore',
    'lq/style'
], function ($, Drop, util, _, Style) {
    'use strict';

    var defaults = {
        data: {
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            top: 0,
            left: 0
        }
    };

    function RadioButtonGroupV2(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);
        this.value = this.data.value;
    };

    Drop.extend(RadioButtonGroupV2, Drop);

    RadioButtonGroupV2.typeName = 'RadioButtonGroupV2';

    RadioButtonGroupV2.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        this.applyPosition();
    };
    
    RadioButtonGroupV2.prototype.postRender = function () {
        this.addRequiredIndicator();
        this.updateRequiredIndicator();

        if (this.pool[0])
            Style.renderStyles(this, null, this.pool[0].$element, null, null, null, this.pool[0].$element);
    };

    RadioButtonGroupV2.prototype.addRequiredIndicator = function () {
        if (this.pool.length === 0)
            return;

        if (this.data.required && this.data.required.isRequired)
            this.pool[0].$element.addClass('isRequiredField');
        else
            this.pool[0].$element.removeClass('isRequiredField');
    };

    RadioButtonGroupV2.prototype.updateRequiredIndicator = function () {
        if (this.pool.length === 0)
            return;

        if (this.isValid())
            this.pool[0].$element.addClass('hasValidValue');
        else
            this.pool[0].$element.removeClass('hasValidValue');
    };

    RadioButtonGroupV2.prototype.render = function ($element) {
    	return this.createAndRenderDrops($element);
    };

    RadioButtonGroupV2.prototype.radioButtonSelectionChanged = function (valueOfSelection) {
        if (this.value === valueOfSelection)
            return;

        this.value = valueOfSelection;

        // for now both events trigger are always triggered together
        this.triggerEventIfEnabled('selected', valueOfSelection);
        this.triggerEventIfEnabled('changed', valueOfSelection);

        this.updateRequiredIndicator();
    };

    RadioButtonGroupV2.prototype.getValue = function () {
        return this.value;
    };

    RadioButtonGroupV2.prototype.setValue = function (update) {
        var value = update.value === null || update.value === undefined ? update.value : update.value.toString();
        var radioButton = _.find(this.pool, function(drop) {
            return drop.data.value === value;
        });
        if (radioButton) {
            this.value = value;
            radioButton.select();
        } else {
            this.clearValue();
        }

        this.updateRequiredIndicator();
    };

    RadioButtonGroupV2.prototype.clearValue = function () {
        this.value = null;

        _.each(this.pool, function (drop) {
            drop.unselect();
        });

        this.updateRequiredIndicator();
    };

    return RadioButtonGroupV2;
});

